<template>
  <div class="stock-home">
    <!-- 头部 -->
    <ContentHeader :stock-nav="false" :show-back="false" />
    <div class="content-container">
      <div class="query-panel">
        <el-row>
          <el-col :span="8" v-if="canApply">
            <router-link to="/stock/apply">
              <el-card shadow="hover">
                <div class="card-icon">
                  <i class="el-icon-s-order icon icon1" />
                </div>
                <div class="card-text">物资申请</div>
              </el-card>
            </router-link>
          </el-col>
          <el-col :span="8" v-if="canApprove">
            <router-link to="/stock/approve">
              <el-card shadow="hover">
                <div class="card-icon">
                  <i class="el-icon-s-claim icon icon2" />
                </div>
                <div class="card-text">申请审核</div>
              </el-card>
            </router-link>
          </el-col>
          <el-col :span="8" v-if="canMoney">
            <router-link to="/stock/money">
              <el-card shadow="hover">
                <div class="card-icon">
                  <i class="el-icon-s-shop icon icon3" />
                </div>
                <div class="card-text">金额配额</div>
              </el-card>
            </router-link>
          </el-col>
          <el-col :span="8" v-if="canStock">
            <router-link to="/stock/stock">
              <el-card shadow="hover">
                <div class="card-icon">
                  <i class="el-icon-takeaway-box icon icon4" />
                </div>
                <div class="card-text">库存</div>
              </el-card>
            </router-link>
          </el-col>
          <el-col :span="8" v-if="canQuota">
            <router-link to="/stock/quota">
              <el-card shadow="hover">
                <div class="card-icon">
                  <i class="el-icon-document-add icon icon5" />
                </div>
                <div class="card-text">物资领用</div>
              </el-card>
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link to="/stock/logitics">
              <el-card shadow="hover">
                <div class="card-icon">
                  <i class="el-icon-tickets icon icon6" />
                </div>
                <div class="card-text">运单查询</div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import { mapGetters } from 'vuex'
export default {
  name: 'stock-home',
  components: {
    ContentHeader
  },
  data () {
    return {
      canApply: false,
      canMoney: false,
      canApprove: false,
      canStock: false,
      canQuota: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.userInfo.clientAuthorizationCodeList) {
        this.userInfo.clientAuthorizationCodeList.forEach(item => {
          switch (item) {
            case 'stock:apply:apply':
              this.canApply = true
              break
            case 'stock:quota:amount':
              this.canMoney = true
              break
            case 'stock:apply:approve':
              this.canApprove = true
              break
            case 'stock:out:manage':
              this.canStock = true
              break
            case 'stock:quota:quantity':
              this.canQuota = true
              break
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-card {
  text-align: center;
  padding-bottom: 30px;
  width: 90%;
  margin: 30px auto;
}
.icon {
  font-size: 32px;
  margin: 20px;
}
.icon1 {
  color: $base-red;
}
.icon2 {
  color: $base-yellow;
}
.icon3 {
  color: $base-pink;
}
.icon4 {
  color: $base-yellow;
}
.icon5 {
  color: $base-olive;
}
.icon6 {
  color: $base-blue;
}
</style>
